<template>
  <div class="content t-c">
    <title-bar :title="$lang.avatar_title"></title-bar>
    <div class="content-c">
      <div class="content-c--c" :key="timerKey">
        <div
          class="content-c--img"
          v-for="(item, index) in imgList"
          :key="index"
          @click="getAvatar(index)"
        >
          <!-- 装饰背景 -->
          <div
            v-if="index === parseInt($route.query.headUrl)"
            class="avatar-bg"
          ></div>

          <!-- 头像图片 -->
          <div
            v-if="index === parseInt($route.query.headUrl)"
            class="avatar-img"
            :style="{ background: 'url(' + item + ') no-repeat center/cover' }"
          ></div>
          <div
            v-if="index != parseInt($route.query.headUrl)"
            class="avatar-img2"
            :style="{ background: 'url(' + item + ') no-repeat center/cover' }"
          ></div>
        </div>
      </div>
      <van-button @click="Submit" class="custom-button">
        {{ $lang.Enviar }}
      </van-button>
    </div>
  </div>
</template>
<script>
import { SetHeadUrl } from '@/api/common'
export default {
  name: 'Avatar',
  components: {},
  data() {
    return {
      imgList: [
        require('@/assets/img/avatar/avatar_0.jpg'),
        require('@/assets/img/avatar/avatar_1.jpg'),
        require('@/assets/img/avatar/avatar_2.jpg'),
        require('@/assets/img/avatar/avatar_3.jpg'),
        require('@/assets/img/avatar/avatar_4.jpg'),
        require('@/assets/img/avatar/avatar_5.jpg'),
        require('@/assets/img/avatar/avatar_6.jpg'),
        require('@/assets/img/avatar/avatar_7.jpg')
      ],
      timerKey: null
    }
  },
  mounted() {},
  methods: {
    getAvatar(i) {
      this.$route.query.headUrl = i
      this.timerKey++
    },
    async Submit() {
      const data = await SetHeadUrl({
        headUrl: parseInt(this.$route.query.headUrl)
      })
      if (data.status === 'ok') {
        // this.$router.replace("/profile");
        this.$router.go(-1)
        this.$toast({
          message: this.$lang.Sucesso,
          icon: 'success'
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.content-c--c {
  display: flex;
  flex-wrap: wrap; // ✅ 允许换行
  justify-content: space-between; // 头像之间平均分布
  margin: 10px;
  background: @cont-bg;
  border-radius: 15px;
}
.active {
  background: url(../../../assets/img/avatar/img_fg.png) no-repeat;
  background-size: 100% 100%;
  height: 80px;
  width: 80px;
  top: -8px;
  left: -8px;
  position: absolute;
  //   border-radius: 80px;
  // border: 2px solid #076237;
}
.custom-button {
  width: 92%;
  margin-top: 20px;
}

.content-c--img {
  position: relative;
  width: 25%;
  height: 102px;
  display: flex; // 启用 flex 布局
  align-items: center; // 垂直居中
  justify-content: center; // 水平居中
}

.avatar-bg {
  position: absolute;
  top: 0;
  width: 102px;
  height: 102px;
  background: url(../../../assets/img/avatar/img_fg.png) no-repeat center;
  background-size: 100% 100%;
  z-index: 0; // ✅ 放在下层
}

.avatar-img {
  position: relative;
  width: 67px;
  height: 67px;
  margin: auto;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  z-index: 1; // ✅ 放在上层
  border: 2px solid #85cdf9; // ✅ 添加绿色边框
  border-radius: 50%; // ✅ 设置为圆形
  box-sizing: border-box; // ✅ 确保边框不撑大尺寸
}
.avatar-img2 {
  position: relative;
  width: 65px;
  height: 65px;
  margin: auto;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  z-index: 1; // ✅ 放在上层
}
</style>
